export default (editor, config = {}) => {
  const bm = editor.BlockManager;
    bm.add('webrtc_widget', {
        label: 'WebRtc',
        category: 'Media',
        content: {
            type:'webrtc_widget',
            resizable : true,
            style: {
                width: "320px",
                height: "400px"
            }
        },
        attributes: {
            class:'fa fa-video-camera' //icon in the panel
        }
    });
}



// WEBPACK FOOTER //
// ./src/plugins/webrtc/blocks.js